import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import Icon from './svg/indeterminate.svg?react';

export const IndeterminateIcon: FC<SvgIconProps> = props => <SvgIcon component={Icon} {...props} />;
